import { useState, FC, PropsWithChildren, ReactNode, useId } from 'react';

import { Checkbox } from '@lichtblick/photon/atoms/checkbox/checkbox';
import { Label } from '@lichtblick/photon/molecules/label/label';

import styles from './OptionalSubsection.module.scss';

type OptionalSubsectionProps = PropsWithChildren<{
  icon?: ReactNode;
  isOpen?: boolean;
  label: string;
}>;

export const OptionalSubsection: FC<OptionalSubsectionProps> = ({ children, icon, isOpen, label }) => {
  const id = useId();
  const [isSelected, setIsSelected] = useState(isOpen);

  return (
    <div className={styles.option} data-selected={isSelected}>
      <Label bold htmlFor={id}>
        <Checkbox
          defaultChecked={isOpen}
          id={id}
          onChange={({ target }) => setIsSelected((target as HTMLInputElement).checked)}
        />
        <span>{label}</span>
        {icon}
      </Label>
      <fieldset aria-disabled={!isSelected} disabled={!isSelected}>
        <div>{children}</div>
      </fieldset>
    </div>
  );
};
